import { apiSlice } from "../../../app/api/apiSlice";

export const paPipelineSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getPaPipeline: builder.mutation({
			query: () => ({
				url: `/api/v1/admin/internal_users_pipeline/PA/`,
				method: "GET",
			}),
		}),
	}),
});

export const { useGetPaPipelineMutation } = paPipelineSlice;
